import { DataFormClient } from "@affinitysystemsgroup/github-packages-affinity-components/dist";

export const insuranceTypeDataForm: DataFormClient = {
  Name: "",
  Img: "",
  id: "",
  clientId: "",
};
